<template>
    <ul class="dlist">
        <li v-for="(detail,index) in details" :key="index">
            <router-link :to="'/class/'+ detail.id">
                <pic :src="detail.logoUrl" alt width="280px" height="150px" />
                <p>{{detail.name}}</p>
                <p>{{detail.occupationName}} | {{detail.gradeName}}</p>
                <p>开班日期：{{detail.beginTime}}</p>
                <p style="position:relative;">
                    <span>{{detail.enrolment}}人已加入</span>
                    <span style="position:absolute;right:20px;">{{details.school}}</span>
                </p>
                <el-button
                    type="primary"
                    style="width:100px;height:30px;border:0;margin-top:10px;"
                    :style="buttonColor(detail)"
                    size="medium"
                >{{title(detail)}}</el-button>
            </router-link>
        </li>
    </ul>
</template>
<script>
export default {
    name: 'classes',
    props: ['params'],
    data() {
        return {
            details: []
        }
    },
    created() {
        this.getData()
    },
    methods: {
        // 班级数据
        getData() {
            let data = {
                platformId: localStorage.getItem('datas'),
                name: this.params.name,
                offlineOrgId: this.params.offlineOrgId,
                occupationId: this.params.occupationId,
                gradeId: this.params.gradeId,
                orgId: this.params.orgId
            }
            var qs = require('qs')
            this.$axios
                .post(
                    this.$managePath + '/offline/api/class/pageList',
                    qs.stringify(data)
                )
                .then(res => {
                    if (res.data.status == '1') {
                        this.details = res.data.data
                    }
                })
        },
        title(detail) {
            if (detail.checkStatus >= 0 && detail.checkStatus < 3) {
                return '已报名'
            }
            return '申请加入'
        },
        buttonColor(detail) {
            if (detail.checkStatus >= 0 && detail.checkStatus < 3) {
                return {
                    background: '#7c7f82',
                    borderColor: '#7c7f82'
                }
            }
            return {}
        }
    },
    watch: {
        params: {
            deep: true,
            handler() {
                this.getData()
            }
        }
    }
}
</script>
<style scoped>
@import '../assets/css/iconfont.css';
@import '../assets/css/common.css';
@import '../assets/css/index.css';
@import '../assets/css/cms.css';
* {
    list-style: none;
}
.dlist {
    width: 1184px;
    height: auto;
    /* background: #000; */
    margin: 0 auto;
    display: flex;
    /* justify-content: space-between; */
    flex-wrap: wrap;
}
.dlist li {
    width: 280px;
    height: 300px;
    border: 1px solid #ccc;
    margin-bottom: 20px;
    margin-right: 14px;
}
.dlist li p {
    text-align: left;
    margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/classes.vue